import {
    LabelValue,
    ListSection,
    getDefinitionKey,
    getRateSet,
} from "./BillingRateBuilderShared";
import { validateComponentPayload } from "./billingRateBuilderSchemas";

const ComponentDetailModalContent = ({ payload }) => {
    const c = payload?.billingRateComponentPayload?.billingRateComponent;
    const rateSet = getRateSet(c);
    const specificRates = rateSet?.specificRates;
    const defKey = getDefinitionKey(c);
    const rateType = defKey === "perSubscriptionPerMonthBillingRateDefinition"
        ? "PSPM"
        : defKey === "perMemberPerMonthBillingRateDefinition"
            ? "PMPM"
            : "";
    const rateAmount = Array.isArray(specificRates) && specificRates.length > 0
        ? specificRates[0]?.value?.amount
        : rateSet?.defaultRate?.amount;

    const errors = validateComponentPayload(payload).fieldErrors;
    const match = payload?.subCategoryMatch;
    const subCategoryWarning =
        (match?.matchType === "substring" || match?.matchType === "fuzzy") && !match?.confirmed
            ? `Approximate ${match.matchType} match — confirm before submitting`
            : null;

    return (
        <div className="billing-rate-builder__modal-content-body">
            <div className="billing-rate-builder__label-grid">
                <LabelValue
                    label="Component Name"
                    value={c?.componentName}
                    error={errors["componentName"]}
                />
                <LabelValue
                    label="Description"
                    value={c?.description}
                    error={errors["description"]}
                />
                <LabelValue
                    label="Component ID"
                    value={c?.definition?.rateClassifications?.componentId}
                    error={errors["componentId"]}
                />
                <LabelValue
                    label="Rate Sub Category"
                    value={c?.definition?.rateClassifications?.rateSubCategory?.shortName}
                    error={errors["rateSubCategory"] || subCategoryWarning}
                />
                <LabelValue
                    label="Rate Type"
                    value={rateType}
                    error={errors["rateType"]}
                />
                <LabelValue
                    label="Rate Amount"
                    value={rateAmount}
                    error={errors["defaultRateAmount"]}
                />
                <LabelValue label="Tiered" value={payload?.tiered ? "Yes" : "No"} />
                {payload?.tiered && (
                    <LabelValue
                        label="Coverage Tier Set Name"
                        value={c?.definition?.coverageTierSetName ?? "N/A"}
                        error={errors["coverageTierSetName"]}
                    />
                )}
            </div>
            {payload?.tiered && errors["specificRates"] && (
                <p style={{ color: "var(--red)", paddingTop: ".4rem", fontSize: ".85rem" }}>
                    {errors["specificRates"]}
                </p>
            )}
            {Array.isArray(specificRates) && specificRates.length > 0 && (
                <ListSection
                    label="Specific Rates"
                    headers={["Coverage Tier Name", "Rate Amount"]}
                    rows={specificRates.map((r) => [
                        r?.members?.coverageTierName,
                        r?.value?.amount,
                    ])}
                />
            )}
        </div>
    );
};

export default ComponentDetailModalContent;
